module.exports = __webpack_public_path__ + "img/video.c5a1dea3.png";